import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { 
  Box,
  Button,
  Container, 
  TextField, 
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';

import Logo from "../../assets/icons/lusidpay_logo.svg";
import LoadingButton from '../../components/buttons/Button';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { 
  CreatePassword
} from '../../redux/actions/authActions';

import style from "../../global.scss";
import "./styles.scss";

const Data = {
  newPassword: "",
  confirmPassword: ""
}

const CreatePasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);

  const [mode, setMode] = useState(1);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // const handleCreatePassword = () => {
  //   let obj = {
  //     email: formData.userName || ""
  //   };
  //   dispatch(ForgotPassword(obj, setLoading)).then(({res, statusCode}) => {
  //     if(statusCode === 200){
  //       setMode(2);
  //       setFormData({
  //         ...formData,
  //         refId: res.data.ref_id
  //       });
  //     };
  //   })
  // };

  useEffect(() => {
    console.log(location.search.slice(1).split("=")[1])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCreatePassword = () => {
    let tokenArray = location.search.slice(1).split("=")
    if (tokenArray[0] === "token" && tokenArray[1].length > 0) {
      let obj = {
        user_id: tokenArray[1],
        new_password: formData.newPassword,
        confirm_password: formData.confirmPassword
      };

      dispatch(CreatePassword(obj, setLoading)).then(({res, statusCode}) => {
        if(statusCode === 200){
          setMode(2);
        }
      });
    } else {
      toast.error("Invalid token")
    }
  };

  return (
    <Box >
      <Box className='auth__top'>
        <Container maxWidth="lg">
          <Box className='flexCenterSBRow'>
            <img
              src={Logo}
              alt="lusid-logo"
              style={{ width: "180px" }}
              />
            <Typography variant='h5' sx={{ color: style["secondary"] }}>
              {"Business"}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box className="auth flexCenterCenterRow">
          <Box className="auth__content flexCenterCenterRow" 
            p={"25px"}>
            {
              mode === 1
              ?
              <Box className="flex_CenterColumn" gap={"20px"} width={"360px"}>
                <Typography
                  variant='h6'
                  textAlign={"center"}>
                  Enter new password
                </Typography>
                <TextField 
                  variant="outlined"
                  label="New password"
                  name="newPassword"
                  type={newPasswordShow ? "text" : "password"}
                  fullWidth={true}
                  placeholder='Enter your new password'
                  value={formData.newPassword}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: 
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setNewPasswordShow(!newPasswordShow);
                          }}>
                        {
                          newPasswordShow
                          ? <VisibilityOffOutlinedIcon />   
                          : <VisibilityOutlinedIcon />
                        }
                        </IconButton>
                      </InputAdornment>,
                  }}
                  />
                <TextField 
                  variant="outlined"
                  label="Confirm password"
                  name="confirmPassword"
                  type={confirmPasswordShow ? "text" : "password"}
                  fullWidth={true}
                  placeholder='Enter your new password again'
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: 
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setConfirmPasswordShow(!confirmPasswordShow);
                          }}>
                        {
                          confirmPasswordShow
                          ? <VisibilityOffOutlinedIcon />   
                          : <VisibilityOutlinedIcon />
                        }
                        </IconButton>
                      </InputAdornment>,
                  }}
                  />
                <LoadingButton
                  variant='contained' 
                  loading={loading}
                  disabled={
                    formData.newPassword.length < 8 || 
                    formData.newPassword !== formData.confirmPassword 
                  }
                  onClick={handleCreatePassword}>
                  Submit
                </LoadingButton>
                </Box>
              :
                mode === 2
                ?
                <Box className="flex_CenterColumn" gap={"20px"} width={"360px"}>
                  <Typography
                    variant='h6'
                    textAlign={"center"}>
                    You can login with your password
                  </Typography>
                  <Button
                    variant='contained' 
                    onClick={() => navigate("/auth")}>
                    Login
                  </Button>
                </Box>
                :
                <></>
            }
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default CreatePasswordPage;